// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { XNGAGE_ELEMENTS } from "@steiner/XDL/constants";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    openBidDetailsState: state.xOpenBidDetails,
});

export interface OpenBissDetailsBillingAddressStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const billingAddressStyles: OpenBissDetailsBillingAddressStyles = {};

const styles = billingAddressStyles;

const OpenBissDetailsBillingAddress = ({ openBidDetailsState }: Props) => {
    const order = openBidDetailsState.dataView?.salesOrder;

    if (!order) {
        return null;
    }

    const formatCityCommaStateZip = (city: string, state: string, zip: string) => {
        let formattedString = "";
        if (city) {
            formattedString += city;
        }

        if (city && state) {
            formattedString += `, ${state} ${zip}`;
        }
        return formattedString;
    };

    let btFormat = "";
    if (order.orderHeader.billTo && order.orderHeader.billTo.entity && order.orderHeader.billTo.entity.address) {
        btFormat = formatCityCommaStateZip(
            order.orderHeader.billTo.entity.address.city,
            order.orderHeader.billTo.entity.address.state,
            order.orderHeader.billTo.entity.address.postalCode,
        );
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Billing Address")}</Typography>
            <AddressInfoDisplay
                companyName={order.orderHeader.billTo.entity.entityName}
                address1={order.orderHeader.billTo.entity.address.streetLineOne}
                address2={order.orderHeader.billTo.entity.address.streetLineTwo}
                city={btFormat}
                country={order.orderHeader.billTo.entity.address.country}
                phone={order.orderHeader.billTo.entity.phoneNumber}
                postalCode=""
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(OpenBissDetailsBillingAddress),
    definition: {
        displayName: "Open Bids Details Billing Addess",
        allowedContexts: ["OpenBidsDetailsPage"],
        group: XNGAGE_ELEMENTS,
    },
};

export default widgetModule;
